export default __webpack_public_path__ + "static/media/bg.886df3fe.jpg";